import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import IconCheckmark from '@components/common/IconCheckmark/IconCheckmark';
import ConfirmModal from '@components/common/Modals/ConfirmModal/ConfirmModal';
import SettingsModal from '@components/lpc/Pot/AmountModule/Settings/SettingsModal/SettingsModal';
import { personRoles } from '@models/PotModel/personRoles';
import { potType } from '@propTypes/potTypes';

import css from './Settings.module.scss';

type ThanksParticipantsProps = {
    pot?: potType;
    newPoolObjective: (potObjectiveType) => void;
    isVisible: boolean;
    mobileView: boolean;
    openSetting?: boolean;
};

const Settings = ({ pot, isVisible, mobileView, newPoolObjective, openSetting }: ThanksParticipantsProps) => {
    const { t } = useTranslateLpc(['lpc-create-pot', 'lpc-pot']);

    const [showReviveSuccessModal, setShowReviveSuccessModal] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const router = useRouter();

    useEffect(() => {
        setOpenSettings(openSetting);
    }, [openSetting]);

    useEffect(() => {
        if (pot.personRole === personRoles.ORGANISER && router.query.showSettings === 'true') {
            setOpenSettings(true);
        }
    }, []);

    return (
        <>
            {isVisible && (
                <>
                    <SettingsModal
                        isVisible={openSettings}
                        onHide={() => setOpenSettings(false)}
                        onConfirm={() => setOpenSettings(false)}
                        onShowReviveSuccessModal={() => {
                            setShowReviveSuccessModal(true);
                        }}
                        pot={pot}
                        newPoolObjective={(objective) => newPoolObjective(objective)}
                    />

                    <ConfirmModal
                        onHide={() => setShowReviveSuccessModal(false)}
                        title={t('settings.revives.revives-sent')}
                        text={t('settings.revives.revives-sent-desc')}
                        cancelLabel={t('settings.revives.return-pot')}
                        isVisible={showReviveSuccessModal}
                        iconComponent={<IconCheckmark variant={'success'} />}
                    />
                    <div>
                        <div className={mobileView ? css.mobile_settings : css.settings}>
                            <Button
                                customClass={!mobileView ? css.settings__cta : css.mobile_settings__cta}
                                variant={'white'}
                                onClick={() => setOpenSettings(true)}
                                isDisabled={pot.isOffered}
                            >
                                {!mobileView && t('amount.cta.settings')}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Settings;
